// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NutritionCalculatorWrapperStyle-module--wrapper--17IuO","text":"NutritionCalculatorWrapperStyle-module--text--1_PQF"};